import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";

function ExamsDropDown(props) {
    const [AccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID] = useState(localStorage.getItem("ID"));
    const [MemberType] = useState(localStorage.getItem("MemberType"));
    const [Exams, setExams] = useState([]);
    const [loading, setLoading] = useState(false);

    const sessionId = parseInt(props.SessionID, 10) || 0;

    useEffect(() => {
        setLoading(true);
        const apiData = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType || "Admin",
            pageNo: 1,
            pageSize: 1000,
            SchoolID: 1,
            SessionID: sessionId,
        };

        const api_config = {
            method: "post",
            url: config.base_url + "Exam/GetAllExams",
            headers: {
                "Content-Type": "application/json",
            },
            data: apiData,
        };

        axios(api_config)
            .then(function (response) {
                if (response.data.status_code === 1) {
                    setExams(response.data.ListofRecords || []);
                } else {
                    setExams([]);
                }
                setLoading(false);
            })
            .catch(function () {
                setExams([]);
                setLoading(false);
            });
    }, [AccessKey, UserID, MemberType, sessionId]);

    if (loading) {
        return <option value="" disabled>Loading...</option>;
    }

    return Exams.map((item, index) => (
        <option value={item.ID} key={index}>
            {item.Exam_Code + " " + item.Name}
        </option>
    ));
}

export default ExamsDropDown;
